import * as React from 'react';
import { fours } from '../../styles/variables';

import AccessibleSVG from '../accessible-svg';

var IconDrawAnnotationMode = function IconDrawAnnotationMode(_ref) {
    var _ref$className = _ref.className,
        className = _ref$className === undefined ? '' : _ref$className,
        _ref$color = _ref.color,
        color = _ref$color === undefined ? fours : _ref$color,
        _ref$height = _ref.height,
        height = _ref$height === undefined ? 21 : _ref$height,
        title = _ref.title,
        _ref$width = _ref.width,
        width = _ref$width === undefined ? 22 : _ref$width;
    return React.createElement(
        AccessibleSVG,
        {
            className: 'icon-annotation-draw ' + className,
            height: height,
            title: title,
            viewBox: '0 0 14.88 14.88',
            width: width
        },
        React.createElement('path', {
            className: 'fill-color',
            d: 'M11.65,6.64,5.11,13.17.06,14.94,1.83,9.89,8.37,3.35Zm1.41-1.41L9.78,1.94,11.37.35a1,1,0,0,1,1.41,0l1.87,1.87a1,1,0,0,1,0,1.41Z',
            fillRule: 'evenodd',
            fill: color
        })
    );
};

IconDrawAnnotationMode.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    height: PropTypes.number,

    /** A text-only string describing the icon if it's not purely decorative for accessibility */
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    width: PropTypes.number
};
export default IconDrawAnnotationMode;
import PropTypes from 'prop-types';